XPortal.GridSizing = (function () {
    const self = {
        isGridVisible: function (gridEl) {
            const gridInfo = XPortal.Grid.GetGridInfo(gridEl);
            return gridInfo.parent.length && gridInfo.parent.is(':visible');
        },

        getDefaultMinHeight: function (gridEl) {
            const $popupWrapper = gridEl.closest('.modal-body-content');
            return $popupWrapper.length ? 155 : 304;
        },

        calculateGridHeight: function (gridEl, gridInfo, defaultMinHeight) {
            const element = self.findGridElement(gridEl);
            const elementPosition = XPortal.Utils.getPosition(element[0]);
            const $sectionWrapper = gridEl.closest('.xsection');
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $popupDetailWrapper = gridEl.closest('.extended-popup-box .modal-body');
            const windowHeight = document.documentElement.clientHeight;
            const pageFooterHeight = $('.footer').outerHeight();
            let gridHeight = 0;
            //console.log('start calc for: - grid height recalc - ' + gridInfo.nodeId);
            if ($popupWrapper.length) {
                gridHeight = self.calculatePopupGridHeight($popupWrapper);
            } else {
                const $contentWrapper = gridEl.closest('.content-wrapper');
                const contentWrapperPaddingBottom = $contentWrapper.length ? (parseFloat($contentWrapper.css('padding-bottom')) || 0) : 0;
                const base = windowHeight - elementPosition.top - pageFooterHeight - contentWrapperPaddingBottom - 4;
                const hasRemoveMargin = $sectionWrapper.length && $sectionWrapper.is('.remove-margin-bottom');
                gridHeight = base - (hasRemoveMargin ? 0 : 12);
            }
            if($popupDetailWrapper.length) {
                gridHeight = self.calculatePopupDetailGridHeight($popupDetailWrapper);
            }

            if ($sectionWrapper.length && $sectionWrapper.hasClass('maximized')) {
                gridHeight = self.calculateMaximizedSectionGridHeight($sectionWrapper, gridInfo);
            } else {
                gridHeight = self.calculateRegularGridHeight(gridInfo, gridHeight);
            }

            gridHeight = self.applyStaticHeight(gridEl, gridHeight);
            gridHeight = self.adjustGridHeight(gridEl, gridInfo, gridHeight, defaultMinHeight);
            return Math.max(gridHeight, defaultMinHeight);
        },

        findGridElement: function (gridEl) {
            let element = gridEl.filter(':visible').length ? gridEl : gridEl.next('.entity-list');
            if (!element.length) {
                element = gridEl.closest('.k-pane-wrapper').next('.entity-list');
            }
            return element;
        },

        calculatePopupGridHeight: function ($popupWrapper) {
            const contentHeight = self.getElementOuterHeight($popupWrapper.find('.addto-top-content:visible'));
            const smallContentHeight = self.getElementOuterHeight($popupWrapper.find('.addto-top-small-content:visible'));
            return $popupWrapper.outerHeight() - contentHeight - smallContentHeight;
        },

        calculatePopupDetailGridHeight: function ($popupDetailWrapper) {
            const gridHeaderHeight = self.getElementOuterHeight($popupDetailWrapper.find('.grid-action-header'));
            return $popupDetailWrapper.height() - gridHeaderHeight; 
        },

        calculateMaximizedSectionGridHeight: function ($sectionWrapper, gridInfo) {
            const $sectionBgwrapper = $sectionWrapper.find('>.xbgdecoration-wrap');
            const blockHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('>.xbgdecoration-wrap>.block-header'));
            const gridHeaderHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
            return $sectionWrapper.height() - self.GetElementVarticalOffset($sectionBgwrapper[0]) - blockHeaderHeight - gridHeaderHeight - 16;
        },

        calculateRegularGridHeight: function (gridInfo, gridHeight) {
            const $gridParent = gridInfo.parent;
            const $sectionContentOfGridParent = $gridParent.parent();
            const $gridParentHeightAttr = parseInt($gridParent.attr('data-height')) || 0;
            const $sectionContentOfGridParentHeightAttr = parseInt($sectionContentOfGridParent.attr('data-height')) || 0;
            const heightAttr = Math.max($gridParentHeightAttr, $sectionContentOfGridParentHeightAttr);
            const isHeightAttrValid = heightAttr > 0;
            const gridheaderHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header')) + 2;
            return isHeightAttrValid ? heightAttr - gridheaderHeight : gridHeight;
        },

        applyStaticHeight: function (gridEl, gridHeight) {
            const gridStaticHeightAttr = gridEl.parent('.grid-parent').attr('data-static-height');
            if (gridStaticHeightAttr >= 0) {
                gridHeight = Number(gridStaticHeightAttr);
            }
            return gridHeight;
        },

        adjustGridHeight: function (gridEl, gridInfo, gridHeight, defaultMinHeight) {
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $sectionWrapper = gridEl.closest('.xsection');
            const isSectionMaximized = $sectionWrapper.length && $sectionWrapper.hasClass('maximized');

            let finalHeight = gridHeight;

            if (!isSectionMaximized) {
                finalHeight = self.adjustRegularGridHeight(gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo, $popupWrapper);
            }

            finalHeight = self.adjustHeightForSiblingSections(gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo);

            // if (window.innerWidth <= 768) {
            //     finalHeight = self.calculatePixelsFromVh('67vh');
            // }

            finalHeight = self.applyStaticHeight(gridEl, finalHeight);
            return finalHeight;
        },

        calculatePixelsFromVh: function (vh) {
            const val = parseFloat(vh);
            if (isNaN(val)) return 0;
            return Math.floor((val * window.innerHeight) / 100);
        },

        adjustRegularGridHeight: function (gridEl, $sectionWrapper, gridHeight, defaultMinHeight, gridInfo, $popupWrapper) {
            const $halfSizeSection = gridEl.closest('.half-size-grid');
            const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
            const footerHeight = self.getElementOuterHeight(gridInfo.parent.find('.k-grid-footer'));
            let finalHeight = gridHeight;
            if ($halfSizeSection.length) {
                const $nextSectionWrapper = gridInfo.parent.next('.xsection.col-12');
                const pageFooterHeight = $('.footer').outerHeight();
                let sectionHeaderHeight = self.getElementOuterHeight($halfSizeSection.find('>.xbgdecoration-wrap>.block-header'));
                const halfSizeSectionOffset = self.GetElementVarticalOffset($halfSizeSection[0]) + 2 + self.GetElementVarticalOffset($nextSectionWrapper[0]);
                const $gridActionHeader = $halfSizeSection.find('.grid-action-header');
                const gridActionHeaderHeigth = self.getElementOuterHeight($gridActionHeader);
                sectionHeaderHeight += gridActionHeaderHeigth;
                finalHeight = self.calculateHalfSizeGridHeight(gridHeight, headerHeight, pageFooterHeight, sectionHeaderHeight, halfSizeSectionOffset);
            } else {

                const sctSttgsHgt = (XPortal.SectionBlock.getOptions($sectionWrapper) || {}).Height || {};
                const lstExtraHgt = gridInfo.list.is(':visible') && !gridInfo.grid.is(':visible') ? 1 : 0;
                const gszExact = Math.min(sctSttgsHgt.Max || 99999, sctSttgsHgt.Exact || 99999);
                if (gszExact > 0 && gszExact < 99999) {
                    const cheight = gszExact;
                    //console.log('----grid height recalc - ' + gridInfo.nodeId + 'cntr=' + cheight + ',hdr=' + headerHeight + ',ftr=' + footerHeight, { sctSttgsHgt, lstExtraHgt, stack: new Error().stack });
                    if (cheight > 0)
                        return finalHeight = cheight - headerHeight - footerHeight - lstExtraHgt;
                }

                if (finalHeight < defaultMinHeight) {
                    finalHeight = defaultMinHeight;
                }
            }

            return finalHeight;
        },

        isSizedRelatedSection: function ($section) {
            const width = XPortal.Utils.getViewportStateForCurrentResolution($section.attr('class') || '', XPortal.Utils.getViewportName());
            return !(width === 12 || $section.find('.xmapviewblock').length > 0);
        },

        adjustRelatedSectionsInit: function (gridEl) {
            const gridElId = gridEl.data('id');
            const $relatedSections = $(`[data-parentid="${gridElId}"]`);
            $relatedSections.each(function () {
                const $section = $(this);
                if (!$section.hasClass('filter-init-done')) {
                    const $filterContainer = $section.find('.filter-set-summary__items-scroll-container');
                    if ($filterContainer.length && self.isSizedRelatedSection($section) && !$filterContainer.closest('.fs-wide-container').length) {
                        $filterContainer.css({ 'height': 0, 'overflow': 'hidden' });
                    }
                    $section.addClass('filter-init-done');
                }
            });
        },

        calculateHalfSizeGridHeight: function (gridHeight, headerHeight, pageFooterHeight, sectionHeaderHeight, halfSizeSectionOffset) {
            const windowHeight = $(window).height();
            const contentWrapperOffset = self.GetElementVarticalOffset($('.content-wrapper')[0]);

            if (window.matchMedia('(min-width: 1024px)').matches || (window.matchMedia('(orientation: portrait)').matches && window.matchMedia('(max-width: 1023.98px)').matches)) {
                return (windowHeight - headerHeight - pageFooterHeight - contentWrapperOffset) / 2 - sectionHeaderHeight - halfSizeSectionOffset;
            }
            if (window.matchMedia('(max-width: 767px)').matches) {
                return $(window).height() / 2 - 2 * headerHeight - pageFooterHeight - contentWrapperOffset;
            }
            return gridHeight;
        },

        adjustHeightForSiblingSections: function (gridEl, $sectionWrapper, finalHeight, defaultMinHeight, gridInfo) {
            const $sectionSiblings = $sectionWrapper.siblings();
            if ($sectionSiblings.length > 0 && XPortal.Utils.getPosition($sectionSiblings[0]).top === XPortal.Utils.getPosition($sectionWrapper[0]).top) {
                const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));
                const footerHeight = self.getElementOuterHeight(gridInfo.parent.find('.k-grid-footer'));
                const blockHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('>.xbgdecoration-wrap>.block-header'));
                const blockHeaderOffset = blockHeaderHeight > 0 ? 16 : 0;
                const sectionWrapperOffset = $sectionWrapper.hasClass('remove-paddings') ? 2 : 34;
                gridEl.closest('.grid-parent').css('margin-bottom', $sectionSiblings.find('.comments-wrap').length ? '1rem' : 0);
                finalHeight = $sectionSiblings.height() - headerHeight - footerHeight - blockHeaderHeight - blockHeaderOffset - sectionWrapperOffset;

                if ($sectionWrapper.parents().is('.tab-content') && $sectionSiblings.find('.filter-set-summary__items')) {
                    finalHeight = $(window).height() - XPortal.Utils.getPosition(gridEl.closest('.xsection')[0]).top - $('.footer').outerHeight();
                    const gridBlockHeaderHeight = self.getElementOuterHeight(gridEl.closest('.xbgdecoration-wrap').find('> .block-header'));
                    const gridSectionPaddingsOffset = self.GetElementVarticalOffset(gridEl.closest('.xsection').find('>.xbgdecoration-wrap')[0]) + self.GetElementVarticalOffset(gridEl.closest('.xsection')[0]);

                    const headerSiblingHeight = self.getElementOuterHeight($sectionSiblings.find('> .xbgdecoration-wrap > .block-header'));
                    const ssSiblingPaddingsOffset = $sectionSiblings.hasClass('remove-paddings') ? 16 : 32;
                    const siblingFilterButtonHeight = self.getElementOuterHeight($sectionSiblings.find('.dynamic-filter-button-wrp'));
                    const totalSiblingFilterHeight = finalHeight - headerSiblingHeight - ssSiblingPaddingsOffset - siblingFilterButtonHeight;
                    $sectionSiblings
                        .find(".filter-set-summary__items")
                        .css({ height: totalSiblingFilterHeight, overflow: "auto" })
                        .addClass("custom-scroll-vertical")
                        .removeClass("h-100");

                    $sectionSiblings.each(function () {
                        const $siblingSectionInTab = $(this);
                        const siblingsBlockHeaderHeight = self.getElementOuterHeight($siblingSectionInTab.find('> .xbgdecoration-wrap > .block-header'));
                        const siblingSectionInTabHeaderHeight = siblingsBlockHeaderHeight ? 0 : gridBlockHeaderHeight;
                        const ssMainSummaryHeight = self.getElementOuterHeight($siblingSectionInTab.find('.dynamic-filter-summary_main'));
                        const ssMainFilterButtonHeight = self.getElementOuterHeight($siblingSectionInTab.find('.dynamic-filter-button-wrp'));
                        const ssMainFiltersHeader = self.getElementOuterHeight($siblingSectionInTab.find('.filter-set-summary__header'));
                        const ssGridSectionPaddingsOffset = $siblingSectionInTab.hasClass('remove-paddings') ? 16 : 32;
                        const ssTotalFiltersHeight = finalHeight - ssMainFiltersHeader - ssMainSummaryHeight - ssMainFilterButtonHeight - ssGridSectionPaddingsOffset + headerHeight + siblingSectionInTabHeaderHeight + gridSectionPaddingsOffset;

                        $siblingSectionInTab.find('.filter-set-summary__items')
                            .css({ 'height': ssTotalFiltersHeight, 'overflow': 'auto' })
                            .addClass('custom-scroll-vertical')
                            .removeClass('h-100');
                    }.bind(this));
                }
            }
            return finalHeight;
        },

        getElementOuterHeight: function ($element) {
            return $element.length > 0 ? $element.outerHeight() : 0;
        },

        getHiddenElementHeight: function (element) {
            const clonedElement = element.cloneNode(true);
            clonedElement.style.visibility = 'hidden';
            clonedElement.style.position = 'absolute';
            document.body.appendChild(clonedElement);
            const height = clonedElement.offsetHeight;
            document.body.removeChild(clonedElement);
            return height;
        },

        setGridHeight: function (gridEl, gridHeight) {
            gridEl.css('height', gridHeight);
        },

        getListView: function (gridEl) {
            const $listView = gridEl.next('.entity-list');
            return $listView.length ? $listView : gridEl.closest('.k-pane-wrapper').next('.entity-list');
        },

        adjustListViewHeight: function (gridEl, gridHeight) {
            const $listView = self.getListView(gridEl);
            if ($listView.length) {
                $listView.css('height', gridHeight);
                const $listContent = $listView.find('.k-listview-content');
                const isVisible = $listView.is(':visible');
                const $listPager = $listView.find('.k-listview-pager').filter(function () { return $(this).css('display') !== 'none'; });
                const footerHeight = $listPager.length ? $listPager.outerHeight() : 0;
                if (isVisible) {
                    const availableHeight = Math.max(0, Math.floor($listView[0].clientHeight - footerHeight));
                    $listContent.css({ 'height': availableHeight + 'px', 'max-height': availableHeight + 'px', 'overflow-y': 'auto' });
                } else {
                    $listContent.css({ 'height': '', 'max-height': (gridHeight - footerHeight) + 'px', 'overflow-y': 'auto' });
                }
                requestAnimationFrame(() => {
                    const hasActiveScroll = $listContent[0] ? ($listContent[0].scrollHeight > $listContent[0].clientHeight) : false;
                    if (hasActiveScroll) {
                        $listContent.addClass('with-scroll').removeClass('no-scroll');
                        $listContent.css('padding-right', '0px');
                    } else {
                        $listContent.addClass('no-scroll').removeClass('with-scroll');
                        $listContent.css('padding-right', '');
                    }
                });
            }
        },

        getMainGridSectionHeight: function (gridEl) {
            return (gridEl.parents('.grid-parent').outerHeight() || 0) - (gridEl.data('row-fill') || 0);
        },

        canFillRow: function (gridEl, gridInfo) {
            const $gridParent = gridInfo.parent;
            const $sectionWrapper = gridEl.closest('.xsection');
            if (!$gridParent.length || $sectionWrapper.hasClass('maximized')) return false;
            if (gridEl.closest('.modal-body-content, .extended-popup-box, .half-size-grid').length) return false;
            if ($gridParent.attr('data-static-height') >= 0) return false;
            if ((parseInt($gridParent.attr('data-height')) || 0) > 0 || (parseInt($gridParent.parent().attr('data-height')) || 0) > 0) return false;
            const sctSttgsHgt = (XPortal.SectionBlock.getOptions($sectionWrapper) || {}).Height || {};
            return !(sctSttgsHgt.Exact > 0 || sctSttgsHgt.Max > 0);
        },

        getMarginBox: function (el) {
            const rect = el.getBoundingClientRect();
            const cs = window.getComputedStyle(el);
            return { top: rect.top - (parseFloat(cs.marginTop) || 0), bottom: rect.bottom + (parseFloat(cs.marginBottom) || 0) };
        },

        getNaturalMarginBox: function (el) {
            const prevAlignSelf = el.style.alignSelf;
            el.style.alignSelf = 'flex-start';
            const box = self.getMarginBox(el);
            el.style.alignSelf = prevAlignSelf;
            return box;
        },

        getRowItem: function ($gridParent) {
            const candidates = [$gridParent[0]].concat($gridParent.parents('.xsection').get());
            for (let i = 0; i < candidates.length; i++) {
                const item = candidates[i];
                const top = self.getMarginBox(item).top;
                const $siblings = $(item).siblings(':visible').filter(function () {
                    return Math.abs(self.getMarginBox(this).top - top) < 4;
                });
                if ($siblings.length) return { item: item, $siblings: $siblings };
            }
            return null;
        },

        getRowFillGap: function (rowItem) {
            const ownBottom = self.getNaturalMarginBox(rowItem.item).bottom;
            let targetBottom = null;
            rowItem.$siblings.each(function () {
                let siblingFill = 0;
                $(this).find('.entity-grid').each(function () { siblingFill += $(this).data('row-fill') || 0; });
                const bottom = self.getNaturalMarginBox(this).bottom - siblingFill;
                if (targetBottom === null || bottom > targetBottom) targetBottom = bottom;
            });
            return targetBottom === null ? null : Math.floor(targetBottom - ownBottom);
        },

        fillRowHeight: function (gridEl) {
            const baseHeight = gridEl.data('base-grid-height');
            if (baseHeight === undefined || !self.isGridVisible(gridEl)) return;
            const gridInfo = XPortal.Grid.GetGridInfo(gridEl);
            const currentFill = gridEl.data('row-fill') || 0;
            const rowItem = self.canFillRow(gridEl, gridInfo) ? self.getRowItem(gridInfo.parent) : null;
            const gap = rowItem ? self.getRowFillGap(rowItem) : null;
            const fill = gap === null ? 0 : Math.max(0, currentFill + gap);
            if (Math.abs(fill - currentFill) < 1) return;
            gridEl.data('row-fill', fill);
            const gridHeight = baseHeight + fill;
            self.setGridHeight(gridEl, gridHeight);
            self.adjustListViewHeight(gridEl, gridHeight);
            self.adjustParentHeight(gridEl, gridInfo, gridHeight);
            self.resizeKGrid(gridInfo);
        },

        observeRowSiblings: function (gridEl) {
            if (!window.ResizeObserver) return;
            const gridInfo = XPortal.Grid.GetGridInfo(gridEl);
            const rowItem = gridInfo.parent.length ? self.getRowItem(gridInfo.parent) : null;
            if (!rowItem) return;
            let observer = gridEl.data('row-fill-observer');
            if (!observer) {
                let frame = 0;
                observer = new ResizeObserver(function () {
                    cancelAnimationFrame(frame);
                    frame = requestAnimationFrame(function () { self.fillRowHeight(gridEl); });
                });
                gridEl.data('row-fill-observer', observer);
            }
            rowItem.$siblings.each(function () { observer.observe(this); });
        },

        adjustParentHeight: function (gridEl, gridInfo, gridHeight) {
            const $filters = gridInfo.parent.find('.filters-list-wrapper.static');
            const filtersHeight = $filters.length && $filters.is(':visible') ? $filters.outerHeight(true) : 0;
            const parentHeight = gridHeight + filtersHeight;
            const $popupWrapper = gridEl.closest('.modal-body-content');
            const $sectionWrapper = gridEl.closest('.xsection');
            const isSectionMaximized = $sectionWrapper.length && $sectionWrapper.hasClass('maximized');
            const headerHeight = self.getElementOuterHeight(gridInfo.parent.find('.grid-action-header'));

            if (!isSectionMaximized) {
                gridInfo.parent.css('height', ($popupWrapper.length ? parentHeight : parentHeight + headerHeight));
            } else {
                gridInfo.parent.css('height', parentHeight + headerHeight);
            }
        },

        adjustSectionContentHeight: function (gridEl) {
            const $sectionWrapper = gridEl.closest('.xsection');
            if ($sectionWrapper.length) {
                $sectionWrapper.children('.section-content').children('.xcontent').css({
                    'min-height': '',
                    'height': ''
                });
            }
        },

        resizeKGrid: function (gridInfo) {
            if (gridInfo.kgrid) {
                gridInfo.kgrid.resize();
            }
        },

        adjustGridHeaderHeight: function (gridEl) {
            setTimeout(function () {
                if (!gridEl.hasClass('height-resized')) {
                    let gridHeightDiv = 0;
                    const gridHeaderHide = gridEl.data('hide-grid-header') === 'True';
                    if (gridHeaderHide) {
                        const $groupingHeader = gridEl.find('.k-grouping-header');
                        if ($groupingHeader.length) {
                            gridHeightDiv += $groupingHeader.outerHeight();
                        }
                        if (gridEl.closest('.k-pane-wrapper').length) {
                            gridHeightDiv -= 17;
                        }
                        const $gridContent = gridEl.find('.k-grid-content');
                        const $gridContentLocked = gridEl.find('.k-grid-content-locked');
                        $gridContent.height($gridContent.height() + gridHeightDiv);
                        $gridContentLocked.height($gridContentLocked.height() + gridHeightDiv);
                    }
                    gridEl.addClass('height-resized');
                    setTimeout(function () {
                        gridEl.removeClass('height-resized');
                    }, 120);
                }
            }, 100);
        },

        adjustRelatedSections: function (gridEl, gridInfo) {
            const gridElId = gridEl.data('id');
            const $relatedSections = $(`[data-parentid="${gridElId}"]`);
            setTimeout(function () {
                $relatedSections.each(function () {
                    const $relatedSectionEl = $(this);
                    self.AdjustRelatedSectionsHeight($relatedSectionEl, gridEl, gridInfo);
                });
            }, 200);
        },

        setInitialHeight: function ($element) {
            $element.css({ 'height': 'initial', 'overflow': 'initial' })
                .removeClass('custom-scroll-vertical')
                .removeClass('h-100');
        },

        setElementHeight: function ($element, height) {
            $element.css({ 'height': height })
                .addClass('custom-scroll-vertical')
                .removeClass('h-100');
        },

        updateDetailScroll: function ($detail) {
            if (!$detail || !$detail.length) return;
            const detailEl = $detail[0];
            const getOverflow = function () { return detailEl.scrollHeight - detailEl.clientHeight; };

            let overflow = getOverflow();
            if (overflow > 1) {
                const $grids = $detail.find('.entity-grid');
                const allGridsEmpty = $grids.length > 0 && _.every($grids, function (g) {
                    const kgrid = $(g).data('kendoGrid');
                    return kgrid && kgrid.dataSource.total() === 0;
                });
                if (allGridsEmpty) {
                    const minEmptyGridHeight = 120;
                    const shrink = function ($el) { return Math.max(minEmptyGridHeight, Math.floor($el.outerHeight() - overflow)); };
                    $detail.find('.grid-parent, .entity-grid').each(function () {
                        if (this.style.height) $(this).css('height', shrink($(this)));
                    });
                    $grids.each(function () {
                        const $grid = $(this);
                        const $list = self.getListView($grid);
                        if ($list.length && $list[0].style.height) self.adjustListViewHeight($grid, shrink($list));
                        self.resizeKGrid(XPortal.Grid.GetGridInfo($grid));
                    });
                    overflow = getOverflow();
                }
            }

            const needsScroll = overflow > 1;
            $detail.css('overflow', needsScroll ? 'auto' : 'hidden')
                .toggleClass('custom-scroll-vertical', needsScroll);
        },

        observeDetailSize: function ($detail) {
            if (!window.ResizeObserver || $detail.data('size-observed')) return;
            $detail.data('size-observed', true);
            let lastHeight = 0;
            new ResizeObserver(function () {
                const h = $detail[0].clientHeight;
                if (Math.abs(h - lastHeight) < 1) return;
                lastHeight = h;
                self.updateDetailScroll($detail);
            }).observe($detail[0]);
        },

        AdjustRelatedSectionsHeight: function ($relatedSection, gridEl, ginfo) {
            const $currentSection = $relatedSection;

            //detail page case (Quick preview)
            const $detail = $currentSection.find('.section-content .detailblock-viewcontainer');
            if ($detail.length) {
                const isMobile = window.innerWidth < 768;
                let calculatedHeight;
                const getCalculatedHeight = function () {
                    if (calculatedHeight === undefined) {
                        const mainGridSectionHeight = self.getMainGridSectionHeight(gridEl);
                        const detailHeaderHeight = $currentSection.find('.block-header').outerHeight() || 3;
                        const detailPaddings = $currentSection.hasClass('remove-paddings') ? 0 : 35;
                        const sectionTopPadding = parseFloat($currentSection.find('.section-content').css('padding-top')) || 0;
                        const recordNavigator = self.getElementOuterHeight($currentSection.find('.record-navigator'));
                        calculatedHeight = Math.floor(mainGridSectionHeight - detailHeaderHeight - detailPaddings - sectionTopPadding - recordNavigator);
                    }
                    return calculatedHeight;
                };

                $detail.each(function () {
                    const $d = $(this);
                    const cssSized = $d.closest('.xcontent').children('.record-navigator').length > 0;
                    const height = isMobile ? 'unset' : (cssSized ? '' : getCalculatedHeight());
                    $d.css('height', height).removeClass('h-100');
                    self.observeDetailSize($d);
                    self.updateDetailScroll($d);
                });
            }

            if (!self.isSizedRelatedSection($currentSection)) return;
            const tabPane = $currentSection.find('.tab-pane');
            if (tabPane.attr('data-minheight') || tabPane.attr('data-height') || tabPane.attr('data-maxheight')) return;

            const $mainGridSection = gridEl.parents('.grid-parent');
            const isMobileWindow = $(window).width() < 576;
            if ($mainGridSection.hasClass('col-12') && isMobileWindow) return;

            const withTabs = $currentSection.find('.nav-tabs').length > 0;
            const wideFiltersWrapper = $currentSection.find('.fs-wide-container').length > 0;
            let mainGridSectionHeight = self.getMainGridSectionHeight(gridEl);
            const topHeaderHeight = self.getElementOuterHeight($currentSection.find('> .xbgdecoration-wrap > .block-header'));
            const descriptionHeight = self.getElementOuterHeight($currentSection.find('> .xbgdecoration-wrap > .block-header-description'));
            const sectionHeaderHeight = topHeaderHeight + descriptionHeight;
            const $sectionHeightContainer = $currentSection.closest('[data-height]');
            const heightAttr = $sectionHeightContainer.length ? $sectionHeightContainer.attr('data-height') : undefined;
            // grids inside the detail preview are sized by the detail container, not by the related section
            const notInDetail = function () { return $(this).closest('.detailblock-viewcontainer').length === 0; };
            const withRelatedGrid = $currentSection.find('.grid-parent').filter(notInDetail).length > 0;
            const sectionPaddingsOffset = self.GetElementVarticalOffset($currentSection.find('>.xbgdecoration-wrap')[0]);
            const isCollapsed = $currentSection.hasClass('collapsed');

            if (parseInt(heightAttr) > 0) {
                mainGridSectionHeight = parseInt(heightAttr);
            }

            // related sections cases
            const facets = $currentSection.find('.facetfilters-facet-tree').length > 0;
            const facetsList = $currentSection.find('.facetfilters-list-container').length > 0;
            const promouted = $currentSection.find('.filter-set-summary__items').length > 0;
            const comments = $currentSection.find('> .xbgdecoration-wrap > .section-content > .xcontent > .comments-wrap').length > 0;
            const commentsInDetailBlock = $currentSection.find('.detailblock-viewcontainer .comments-wrap').length > 0;
            const halfSizeSection = $currentSection.hasClass('half-size-grid');
            const recordNavigator = self.getElementOuterHeight($currentSection.find('.record-navigator'));
            const contentAreaHeight = mainGridSectionHeight - recordNavigator;

            // half-size section
            if (halfSizeSection) {
                const verticalOffset = self.GetElementVarticalOffset($currentSection[0]);
                const relatedHalfSizeSectionHeight = Math.floor((contentAreaHeight / 2) - verticalOffset);
                self.setElementHeight($currentSection.find('>.xbgdecoration-wrap'), relatedHalfSizeSectionHeight);

                const $relatedGridParent = $currentSection.find('> .xbgdecoration-wrap > .section-content .grid-parent').filter(notInDetail);
                if ($relatedGridParent.length > 0) {
                    const $detailSection = $relatedGridParent.closest('.xdetailssection');
                    $detailSection.css('margin-bottom', 0);
                    const $detailSectionBgElem = $relatedGridParent.closest('.xdetailssection').find('>.xbgdecoration-wrap');
                    const detailOffset = self.GetElementVarticalOffset($detailSection[0]) + self.GetElementVarticalOffset($detailSectionBgElem[0]);
                    const dragAndDropGrid = self.getElementOuterHeight($currentSection.find('.dropzone-container')) + 16;
                    const gridElToResize = $relatedGridParent.find('.entity-grid');
                    const $gridActionHeader = $relatedGridParent.find('.grid-action-header');
                    const gridActionHeaderHeigth = isCollapsed ? self.getHiddenElementHeight($gridActionHeader[0]) : self.getElementOuterHeight($gridActionHeader);

                    const updatedStatikGridHeigth = relatedHalfSizeSectionHeight - sectionHeaderHeight - sectionPaddingsOffset - gridActionHeaderHeigth - dragAndDropGrid - detailOffset;
                    const gridInfo = XPortal.Grid.GetGridInfo(gridElToResize);

                    $relatedGridParent.attr('data-static-height', updatedStatikGridHeigth)
                        .addClass('static-heigth-aplied')
                        .css('margin-bottom', 0)
                        .css('height', 'auto');
                    $relatedGridParent.parent('.xcontent').removeClass('custom-scroll-vertical');
                    self.adjustParentHeight(gridElToResize, gridInfo, updatedStatikGridHeigth + 20);
                    self.setGridHeight(gridElToResize, updatedStatikGridHeigth)
                    self.resizeKGrid(gridInfo);
                }

                return
            }

            // section with setted height
            if ($currentSection.attr('data-minheight') || $currentSection.attr('data-height') || $currentSection.attr('data-maxheight')) {
                return;
            }

            // promouted filters
            if (promouted) {
                if (isCollapsed) return;
                const filterSearchHeight = self.getElementOuterHeight($currentSection.find('.dynamic-filter-summary_search'));
                const filterApplyButtonHeight = self.getElementOuterHeight($currentSection.find('.filter-set-summary > .dynamic-filter-button-wrp'));
                const filtersHeaderHeight = self.getElementOuterHeight($currentSection.find('.filter-set-summary__header'));
                const sectionBgWrapOffset = self.GetElementVarticalOffset($currentSection.find('> .xbgdecoration-wrap')[0]);
                const sectionPaddingsOfset = self.GetElementVarticalOffset($currentSection[0]);
                const totalFiltersHeight = contentAreaHeight - sectionHeaderHeight - filterSearchHeight - filterApplyButtonHeight - filtersHeaderHeight - sectionPaddingsOfset - sectionBgWrapOffset - 12;
                self.setElementHeight($currentSection.find('.filter-set-summary__items-scroll-container'), totalFiltersHeight)
            }

            // facet filters list
            if (facetsList) {
                const sectionPaddingsOfset = $currentSection.hasClass('remove-paddings') ? 0 : 35;
                const totalFiltersHeight = contentAreaHeight - sectionPaddingsOfset - sectionHeaderHeight;
                self.setElementHeight($currentSection.find('.facetfilters-list-container'), totalFiltersHeight)
            }

            //  facet filters tree
            if (facets) {
                const totalFiltersHeight = contentAreaHeight - sectionHeaderHeight - sectionPaddingsOffset;
                self.setElementHeight($currentSection.find('.facetfilters-facet-tree'), totalFiltersHeight)
            }

            // comments
            if (comments && !commentsInDetailBlock) {
                const $commentsWrap = $currentSection.find('> .xbgdecoration-wrap > .section-content > .xcontent > .comments-wrap')
                const $commentsInput = $commentsWrap.find('.comments-cntbc > .cmnt-edit-form');
                const commentsInputCalcHeight = isCollapsed ? 78 : self.getElementOuterHeight($commentsInput) + 32;
                const commentsInputHeight = $commentsInput.hasClass('cmnt-edit-form_bottom') ? commentsInputCalcHeight - 10 : commentsInputCalcHeight;
                const commentsSummaryHeight = self.getElementOuterHeight($commentsWrap.find('.comments-cntbc__summary'));
                const commentsHeight = contentAreaHeight - sectionHeaderHeight - sectionPaddingsOffset - commentsInputHeight - commentsSummaryHeight;
                self.setInitialHeight($currentSection.find('.xbgdecoration-wrap'));
                self.setElementHeight($commentsWrap.find('.comment-items'), commentsHeight)
            }

            // comments in detail block
            if (commentsInDetailBlock) {
                const $commentsWrap = $currentSection.find('.detailblock-viewcontainer .comments-wrap');
                const detaiPageHeaderHeight = self.getElementOuterHeight($currentSection.find('.block-header_entity-detail'));
                const parentsection = $commentsWrap.closest('.xdetailssection');
                const commentsInDetailBlockSiblings = parentsection.siblings('.xdetailssection');
                const $commentsWrapSection = $commentsWrap.closest('.xsection');
                const commentsWrapSectionOffset = $commentsWrapSection.hasClass('remove-paddings') ? 2 : 48;
                const commentsHeight = contentAreaHeight - sectionHeaderHeight - sectionPaddingsOffset - commentsWrapSectionOffset - detaiPageHeaderHeight;
                if (commentsInDetailBlockSiblings.length == 0) {
                    $currentSection.find('.xbgdecoration-wrap')
                        .css('height', "initial")
                        .removeClass('custom-scroll-vertical')
                        .addClass('h-100');
                    self.setElementHeight($currentSection.find('.comments-wrap'), commentsHeight)
                }
            }

            //related section with tabs
            let totalTabContentHeight = 0;
            if (withTabs) {
                const tabsNavHeight = self.getElementOuterHeight($currentSection.find('.nav-tabs'));
                $currentSection.find('> .xbgdecoration-wrap > .section-content').addClass('section-content_with-tabs')

                self.setInitialHeight($currentSection.find('.xbgdecoration-wrap'));
                self.setInitialHeight($currentSection.find('.filter-set-summary__items'));

                const $tabContent = $currentSection.find('.tab-content').first();
                let tabContentOffset = 0;
                let $current = $tabContent.parent();
                while ($current.length && !$current.is($currentSection)) {
                    tabContentOffset += self.GetElementVarticalOffset($current[0]);
                    $current = $current.parent();
                }

                totalTabContentHeight = contentAreaHeight - sectionHeaderHeight - tabsNavHeight - tabContentOffset;
                self.setElementHeight($tabContent, totalTabContentHeight);
            }

            // in case the dragAndDrop and grid in related section
            if (withRelatedGrid) {
                const $relatedGridParent = $currentSection.find('> .xbgdecoration-wrap > .section-content .grid-parent').filter(notInDetail);
                const $currentSectionWrp = $currentSection.find('> .xbgdecoration-wrap');
                const $detailSection = $relatedGridParent.closest('.xdetailssection');
                const $detailSectionBgElem = $relatedGridParent.closest('.xdetailssection').find('>.xbgdecoration-wrap');
                const detailOffset = self.GetElementVarticalOffset($currentSectionWrp[0]) + self.GetElementVarticalOffset($detailSection[0]) + self.GetElementVarticalOffset($detailSectionBgElem[0]);
                const dragAndDropGrid = self.getElementOuterHeight($currentSection.find('.dropzone-container'));
                const tolerance = 17; //padding + border for the list view
                const gridElToResize = $relatedGridParent.find('.entity-grid');
                const $gridActionHeader = $relatedGridParent.find('.grid-action-header');
                const gridActionHeaderHeight = isCollapsed ? self.getHiddenElementHeight($gridActionHeader[0]) : self.getElementOuterHeight($gridActionHeader);

                let updatedStaticGridHeight;
                if (withTabs) {
                    updatedStaticGridHeight = totalTabContentHeight - gridActionHeaderHeight - dragAndDropGrid - tolerance - self.GetElementVarticalOffset($detailSection[0]) - self.GetElementVarticalOffset($detailSectionBgElem[0]);
                } else {
                    updatedStaticGridHeight = contentAreaHeight - sectionHeaderHeight - sectionPaddingsOffset - gridActionHeaderHeight - dragAndDropGrid - detailOffset - tolerance;
                }

                updatedStaticGridHeight = Math.max(0, updatedStaticGridHeight);
                const gridInfo = XPortal.Grid.GetGridInfo(gridElToResize);
                $relatedGridParent.attr('data-static-height', updatedStaticGridHeight).addClass('static-heigth-aplied');
                self.adjustParentHeight(gridElToResize, gridInfo, updatedStaticGridHeight);
                self.setGridHeight(gridElToResize, updatedStaticGridHeight);
                self.adjustListViewHeight(gridElToResize, updatedStaticGridHeight);
                self.resizeKGrid(gridInfo);
            }

            // regular related section
            if (!withTabs && !facets && !facetsList && !promouted && !comments && !wideFiltersWrapper) {
                const contentHeight = mainGridSectionHeight;
                const $sectionBgwrapper = $currentSection.find('>.xbgdecoration-wrap');
                const $sectionVerticalofset = self.GetElementVarticalOffset($currentSection[0]);
                self.setElementHeight($sectionBgwrapper, Math.floor(contentHeight - $sectionVerticalofset));
                // clear height for all inner sections
                $sectionBgwrapper.find('.xbgdecoration-wrap')
                    .css({ 'height': 'auto', 'overflow': 'initial' })
                    .removeClass('custom-scroll-vertical')
                    .removeClass('h-100');
            }
        },
        GetElementVarticalOffset: function (element) {
            if (!element) {
                return 0;
            }

            const computedStyle = window.getComputedStyle(element);

            const paddingTop = parseFloat(computedStyle.getPropertyValue('padding-top')) || 0;
            const paddingBottom = parseFloat(computedStyle.getPropertyValue('padding-bottom')) || 0;
            const marginTop = parseFloat(computedStyle.getPropertyValue('margin-top')) || 0;
            const marginBottom = parseFloat(computedStyle.getPropertyValue('margin-bottom')) || 0;
            const borderTopWidth = parseFloat(computedStyle.getPropertyValue('border-top-width')) || 0;
            const borderBottomWidth = parseFloat(computedStyle.getPropertyValue('border-bottom-width')) || 0;

            return paddingTop + paddingBottom + marginTop + marginBottom + borderTopWidth + borderBottomWidth;
        },
        adjustExpandCollapsePosition: function (gridEl, gridInfo) {
            if (!gridEl) gridEl = gridInfo.grid;
            if (!gridEl) return;
            if (!gridInfo) gridInfo = XPortal.Grid.GetGridInfo(gridEl);

            const $sectionWrapper = gridEl.closest('.xsection');
            const sectionHeaderHeight = self.getElementOuterHeight($sectionWrapper.find('.block-header'));
            const sectionHeaderContainsNoTitle = $sectionWrapper.find('.block-header .no-title-subtitle').length > 0;
            const sectionHeaderNoTitle = sectionHeaderContainsNoTitle || (sectionHeaderContainsNoTitle == false && sectionHeaderHeight < 5);
            const ulbuttons = $(_.find($sectionWrapper.find('.collapse-buttons'), ui => $(ui).closest('.xsection')[0] == $sectionWrapper[0]));
            const gridHeaderHeight = self.getElementOuterHeight(gridInfo.actionsHeader);

            if (!ulbuttons || ulbuttons.length < 1 || sectionHeaderNoTitle == false || gridHeaderHeight < 5) return;
            copySectionButtonsInGrid(gridEl, gridInfo, $sectionWrapper, ulbuttons);
            showHideSectionGridButtons(gridEl, gridInfo, $sectionWrapper, ulbuttons);
        },
        adjustGridHeaderActions: function (gridInfo, gridEl) {
            const $header = gridInfo.actionsHeader;
            const availableWidth = $header.width();
            if (availableWidth <= 0) return;
            if ($header.hasClass('quick-search-below-title')) 
                $header.removeClass("quick-search-below-title");

            const minTitleWidth = 150;
            let m = calculateHeaderMeasurements(gridInfo);
            const titleWidth = Math.min(m.title, minTitleWidth);
            const nonActionWidth = m.selectView + m.sidebar + m.titleOffset + m.actionsOffset + m.sidebarOffset + 20 + titleWidth;
            const $buttonContainer = $header.find('.grid-header-actions');
            const excludedParentSelectors = [
                '.detailblock-viewcontainer',
                '.xsection:has(> .xbgdecoration-wrap > .section-content > .xcontent > div > .dropzone-container)'
            ];
            const isExcluded = excludedParentSelectors.some(
                selector => $header.closest(selector).length > 0
            );

            if (window.innerWidth <= 576 && !isExcluded) {
                $buttonContainer.addClass('is-mobile');
            } else {
                $buttonContainer.removeClass('is-mobile');
            }
            const actionButtons = $buttonContainer.find('.dropdown:not(.show):not(.dots)');
            actionButtons.removeClass('hide-text');
            const buttonsWidth = availableWidth - (nonActionWidth + m.search);
            resizeButtons($buttonContainer, buttonsWidth, m);
            const totalRequiredWidth = nonActionWidth + m.search + m.buttons + m.dots;
            const needsToWrap = totalRequiredWidth > availableWidth;
            $header.toggleClass('quick-search-below-title', needsToWrap);
            updateTitleWidth(gridInfo, needsToWrap, m);
        }
    };

    function calculateHeaderMeasurements(gridInfo) {
        const $header = gridInfo.actionsHeader;
        const $actions = $header.find('.grid-header-actions');
        const $sidebar = $header.children('.grid-header-sidebar');
        const $title = $header.children('.grid-header-title');

        const titleOuter = $title.is(':visible') ? ($title.outerWidth(true) || 0) : 0;
        const actionsOuter = $actions.is(':visible') ? ($actions.outerWidth(true) || 0) : 0;
        const sidebarOuter = $sidebar.is(':visible') ? ($sidebar.outerWidth(true) || 0) : 0;

        return {
            title: $title.find('.dd-header-wrapper').outerWidth(true) || 0,
            selectView: $title.find('.dropdown-toggle').outerWidth(true) || 0,
            sidebar: $sidebar.find('.collapse-buttons').outerWidth(true) || 0,
            search: $actions.find('.quick-search-container').outerWidth(true) || 0,
            buttons: $actions.find('.grid-buttons-inited').outerWidth(true) || 0,
            dots: Math.max($actions.find('.dots').outerWidth(true) || 0, 0),
            titleIcon: $title.find('.dd-header-wrapper__icon').outerWidth(true) || 0,

            titleOffset: Math.max(titleOuter - ($title.width() || 0), 0),
            actionsOffset: Math.max(actionsOuter - ($actions.width() || 0), 0),
            sidebarOffset: Math.max(sidebarOuter - ($sidebar.width() || 0), 0),
        };
    }
    const resizeCache = new WeakMap();
    function resizeButtons($buttonContainer, allowedWidth, m) {
        if (!$buttonContainer.parent().hasClass('grid-header-resize')) {
            $buttonContainer.parent().addClass('grid-header-resize');
        }
        const currentState = {
            width: Math.round(allowedWidth * 100) / 100,
            containerWidth: $buttonContainer.width()
        };
        const cached = resizeCache.get($buttonContainer[0]);

        if (cached && Math.abs(cached.width - currentState.width) < 2 && Math.abs(cached.containerWidth - currentState.containerWidth) < 2) {
            m.buttons = cached.buttons;
            m.dots = cached.dots;
            return;
        }

        XPortal.DropdownBtns.gridButtons.check($buttonContainer, allowedWidth);
        const $actionButtons = $buttonContainer.find('.dropdown.dropdown-hover.desktop-inline:not(.dots)');
        const $dots = $actionButtons.next('.dots');
        m.buttons = $actionButtons.outerWidth(true) || 0;
        m.dots = ($dots.length && !$dots.hasClass('d-none')) ? ($dots.outerWidth(true) || 0) : 0;
        resizeCache.set($buttonContainer[0], {
            width: currentState.width,
            containerWidth: currentState.containerWidth,
            buttons: m.buttons,
            dots: m.dots
        });
    }
    function updateTitleWidth(gridInfo, needsToWrap, m) {
        const $header = gridInfo.actionsHeader;
        const $headerContent = $header.find('.dd-header-cnt');

        if (!$headerContent.length) return;

        const hasRealContent = $headerContent
            .find('.original-title, .dd-header__subtitle')
            .filter(function () {
                const $el = $(this);
                const hasText = $.trim($el.text()).length > 0;
                const hasVisibleChildren = $el.children(':visible').length > 0;
                return hasText || hasVisibleChildren;
            })
            .length > 0;

        if (!hasRealContent) return;

        const gridWidth = $header.width();
        let availableWidth = 0;
        if (needsToWrap) {
            availableWidth = gridWidth - m.selectView - m.titleOffset - m.sidebarOffset - m.sidebar - m.titleIcon - 16;
        } else {
            const actionsRequiredWidth = m.buttons + m.dots + m.search;
            availableWidth = gridWidth - m.selectView - actionsRequiredWidth - m.actionsOffset - m.titleOffset - m.sidebarOffset - m.sidebar - m.titleIcon - 16;
        }
        const safeWidth = Math.max(availableWidth, 0);
        const titleEl = $header.find('.dd-header-wrapper')[0];
        $headerContent.css('width', 'auto');

        const naturalWidth = titleEl.scrollWidth;

        if (naturalWidth > safeWidth) {
            $headerContent.css('width', safeWidth + 'px');
        } else {
            $headerContent.css('width', 'auto');
        }
    };
    function showHideSectionGridButtons(gridEl, gridInfo, $sectionWrapper, ulbuttons) {
        const gridBntsCntr = gridInfo.actionsHeader.find(".grid-rsbtts-wrapper");
        const isSectionCollapsed = $sectionWrapper.hasClass('collapsed');
        const isSectionMaximized = $sectionWrapper.hasClass('maximized');
        hideCollpsBtnIfMaximized(ulbuttons, gridBntsCntr, isSectionMaximized);
        let sectHeader = ulbuttons.closest(".block-header");

        if (!sectHeader.length || !$sectionWrapper.has(sectHeader)) sectHeader = ulbuttons.parent().children(".block-header");
        if (isSectionMaximized || (!isSectionCollapsed && self.isGridVisible(gridEl))) {
            gridBntsCntr.removeClass("d-none");
            sectHeader.addClass("d-none");
            ulbuttons.addClass("d-none");
            return true;
        } else {
            ulbuttons.removeClass("d-none");
            sectHeader.removeClass("d-none");
            gridBntsCntr.addClass("d-none");
            return false;
        };
    };
    function hideCollpsBtnIfMaximized(ulbuttons, gridBntsCntr, isSectionMaximized) {
        const btnCollps = gridBntsCntr.find('.collapse-buttons').find('.collapse-btn');
        if (isSectionMaximized) {
            if (btnCollps.is(":visible")) {
                btnCollps.addClass('d-none');
                btnCollps.addClass('hidden-maximized');
            }
        } else {
            if (btnCollps.hasClass("hidden-maximized")) {
                btnCollps.removeClass('d-none');
                btnCollps.removeClass('hidden-maximized');
            }
        }
    };
    function copySectionButtonsInGrid(gridEl, gridInfo, $sectionWrapper, ulbuttons) {

        const grBtnsCntnr = gridInfo.actionsHeader.find(".grid-rsbtts");
        const sctSttgsHgt = XPortal.SectionBlock.getOptions($sectionWrapper) || {};


        if (grBtnsCntnr.find(".collapse-buttons-" + sctSttgsHgt.Id).length) return;

        var copy = $("<div></div>").append(ulbuttons.clone());
        copy.addClass("collapse-buttons-" + sctSttgsHgt.Id);
        grBtnsCntnr.append(copy);

        const executeRefresh = function () {
            copy.html("");
            copy.append(ulbuttons.clone());
            copy.find(".collapse-buttons").removeClass("d-none");
            showHideSectionGridButtons(gridEl, gridInfo, $sectionWrapper, ulbuttons);
        };
        $(document).on('click', '.collapse-buttons-' + sctSttgsHgt.Id + ' .collapse-buttons li', function (e) {
            const srcEl = $(this);
            const classNames = srcEl.attr('class');
            ulbuttons.find('li').each(function () {
                const dstEl = $(this);
                if (dstEl.attr('class') == classNames) {
                    dstEl.trigger('click');
                };
            });
            executeRefresh();
        });
        $sectionWrapper.on('expanded', executeRefresh);
        $sectionWrapper.on('collapsed', executeRefresh);
        $sectionWrapper.on('maximized', executeRefresh);
        executeRefresh();
    };

    return self;
}());
